<template>
  <div id="place-marker">
    <div id="markers">
      <div v-for="(question, id) in questions" :key="id" :class="question.id == status.position + 1 ? 'marker' + ' active': 'marker'"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "place-marker",
  props: {
    questions: Array,
    status: Object
  }
};
</script>

<style scoped>
#place-marker {
  position: fixed;
  z-index: 99;
  bottom: 32px;
  color: #fff;
  width: 100%;
}
.marker {
  width: 8px;
  height: 8px;
  background: #fff;
  border-radius: 50%;
  display: inline-block;
  margin: 0 10px 0 0;
  opacity: 0.4;
}
.marker.active {
  opacity: 1;
}
.marker:last-child {
  margin: 0;
}
</style>